export default "__VITE_ASSET__CoQvJL2t__"